import React, { Component } from 'react';
import { connect } from 'react-redux';
// import { viewAllSections } from '../List/Actions';
import { Col,  Card } from 'reactstrap';
import withAuth from '../../../components/Services/WithAuth';
import './styles.css';
import CaseCreateForm from './CreateForm/index'
import { clearData } from './actions'
//import Reorder from '../Create/SectionRearrange/index'
class CreateCasesComponent extends Component {
  /* constructor(props) {
    super(props);
  } */
    componentDidUpdate() {
    this.props.clearData()
  }
  render() {
    return (
      <Col>
          <div className="d-flex justify-content-between align-items-center mb-3">
              <h4 className="mb-0">Create Case</h4>
          </div>
          <Card>
              <CaseCreateForm />
          </Card>
      </Col>
    )
  }
}

const mapStateToProps = (state, ownProps) => {

  return {
    //formValue:state.form.syncValidation.values
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    clearData: (corp) => { dispatch(clearData(corp)); }
  };
};

export default withAuth(connect(mapStateToProps, mapDispatchToProps)(CreateCasesComponent))
